import { render, staticRenderFns } from "./EditAboutUsProfile.vue?vue&type=template&id=a95b1980&scoped=true&"
import script from "./EditAboutUsProfile.vue?vue&type=script&lang=js&"
export * from "./EditAboutUsProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a95b1980",
  null
  
)

export default component.exports